import PromoPanel from 'gatsby-theme-husky/src/components/PromoPanel/PromoPanel';

import './PromoPanelOverride.scss';

export default PromoPanel;
